<template>
  <q-btn
    :icon="isSelected === '1' ? 'mdi-close' : 'mdi-cart-outline'"
    :class="'orderable ' + setDisableClass()"
    :disabled="isDisable()"
    :label="isSelected === '1' ? '取消' : '注文'"
    @click="order"
  >
    <q-popup-proxy v-model="popupFlg" transition-show="fade" transition-hide="fade" @show="hide">
      <q-banner>
        <template #avatar>
          <q-icon
            :name="isSelected === '1' ? 'add_shopping_cart' : 'remove_shopping_cart'"
            color="primary"
          />
        </template>
        {{ isSelected === '1' ? '追加されました' : '削除されました' }}
      </q-banner>
    </q-popup-proxy>
  </q-btn>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import OrderQuotableCode from '../../common/code/OrderQuotableCode';

interface Props {
  // 選択フラグ 0:未選択、1:選択済み
  isSelected: string;
  // 注文問合フラグ（注文されてるか、問い合わせされてるか） 0：注文、1:問い合わせ
  orderQuotableFlg: string;
}

const props = defineProps<Props>();
const emit = defineEmits(['order']);

const order = () => {
  emit('order');
};

const isDisable = (): boolean => {
  // 問い合わせまたはエラーの場合、true
  if (props.orderQuotableFlg === OrderQuotableCode.QUOTABLE) {
    return true;
  }
  return false;
};

const setDisableClass = (): string => {
  // 問い合わせまたはエラーの場合、非活性
  if (props.orderQuotableFlg === OrderQuotableCode.QUOTABLE) {
    return 'disabled';
  }

  // 選択済みの場合、活性
  if (props.isSelected === '1') {
    return 'inactive';
  }

  return '';
};

const popupFlg = ref<boolean>(false);

const sleep = (second: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, second * 1000);
  });

const hide = async () => {
  await sleep(0.5);
  popupFlg.value = false;
};
</script>
